// Adaptadores: transformam as duas respostas da API (detalhe autenticado e DTO publico)
// no mesmo formato, consumido pelos componentes de src/components/vehicle.
import { formatNumber, formatMoney, relativeTime } from '@/services/util';

const IMAGEM_PADRAO_PERFIL = '/Content/img/user.png';

export function percentualAbaixoFipe(valor, fipe) {
  const v = Number(valor);
  const f = Number(fipe);
  if (!(v > 0) || !(f > 0) || v >= f) return 0;
  return Math.round((1 - v / f) * 100);
}

function textoKm(km) {
  if (km === null || km === undefined || km === '') return '';
  const n = Number(String(km).replace(/\D/g, ''));
  return isFinite(n) ? formatNumber(n) : String(km);
}

// Detalhe autenticado (GET /v1/negociacoes/{id}/detalhes)
export function fromDetalhe(d, isMobileDevice = false) {
  const arremate = d.valorArremate > 0;
  const maiorOferta = d.valorMaiorOferta > 0;
  const valorExibido = arremate ? d.valorArremate : (maiorOferta ? d.valorMaiorOferta : d.valorPretendido);
  const labelValor = arremate ? 'FECHA AGORA!' : (maiorOferta ? 'MELHOR OFERTA' : 'VALOR INICIAL');

  return {
    marca: d.marca,
    modelo: d.modelo,
    anoFabricacao: d.anoFabricacao,
    anoModelo: d.anoModelo,
    km: textoKm(d.kmFormatado || d.km),
    cor: d.cor,
    portas: d.numeroPortas,
    combustivel: d.combustivel,
    transmissao: d.transmissao,
    carroceria: d.carroceria,
    cidade: d.cidade,
    uf: d.siglaEstado,
    placa: d.placaFormatado || '',
    leilao: !!d.leilao,
    imagens: (d.imagens || []).map(i => ({ url: i.imagemUrl })),
    opcionais: (d.opcionais || []).map(o => o.descricaoOpcional),
    checklist: (d.checklists || []).map(c => ({
      nome: c.checklist,
      descricao: c.descricaoServico || '',
      conservacao: c.conservacao,
    })),
    observacaoHtml: d.observacaoAvaliacao || '',
    valorExibido,
    labelValor,
    valorFipe: d.valorFipe,
    percAbaixoFipe: percentualAbaixoFipe(valorExibido, d.valorFipe),
    contato: {
      nome: d.nomeGerente,
      fotoUrl: d.imagemPerfilGerenteFormatadoUrl || IMAGEM_PADRAO_PERFIL,
      telefone: d.telefoneGerenteFormatado || '',
      whatsappUrl: (isMobileDevice ? d.whatsAppMobileGerenteUrl : d.whatsAppWebGerenteUrl) || d.whatsAppMobileGerenteUrl || '',
    },
  };
}

// DTO publico (GET /v3/links/{token})
export function fromPublico(d) {
  return {
    marca: d.marca,
    modelo: d.modelo,
    anoFabricacao: d.anoFabricacao,
    anoModelo: d.anoModelo,
    km: textoKm(d.km),
    cor: d.cor,
    portas: d.portas,
    combustivel: d.combustivel,
    transmissao: d.transmissao,
    carroceria: d.carroceria,
    cidade: d.cidade,
    uf: d.uf,
    placa: '',
    leilao: false,
    imagens: (d.imagens || []).map(i => ({ url: i.url })),
    opcionais: d.opcionais || [],
    checklist: (d.checklist || []).map(c => ({
      nome: c.nome,
      descricao: '',
      conservacao: c.conservacao,
    })),
    observacao: d.observacao || '',
    valorExibido: d.valorExibido,
    labelValor: d.labelValor,
    valorFipe: d.valorFipe,
    percAbaixoFipe: d.percAbaixoFipe > 0 ? d.percAbaixoFipe : percentualAbaixoFipe(d.valorExibido, d.valorFipe),
    contato: {
      nome: d.contato && d.contato.nome,
      fotoUrl: d.contato && d.contato.fotoUrl,
      telefone: '',
      whatsappUrl: '',
    },
  };
}

// Detalhe da vitrine (GET /v3/vitrine/{codigo}): o DTO publico do link mais a placa mascarada e o selo de leilao.
export function fromVitrine(d) {
  return {
    ...fromPublico(d),
    placa: d.placaFormatado || '',
    leilao: !!d.leilao,
  };
}

// Card da vitrine publica (GET /v3/vitrine). A API manda so o valor exibido (Fecha Agora ou valor inicial),
// nunca a maior oferta; o card mostra esse valor com o rotulo certo e o percentual abaixo da FIPE.
export function cardFromVitrine(i) {
  const fechaAgora = i.labelValor === 'FECHA AGORA!';
  const valor = formatMoney(i.valorExibido);
  return {
    imagemUrl: i.imagemCapaReduzidaUrl || i.imagemCapaUrl,
    leilao: !!i.leilao,
    marca: i.marca,
    modelo: i.modelo,
    anoFabricacao: i.anoFabricacao,
    anoModelo: i.anoModelo,
    combustivel: i.combustivel,
    km: textoKm(i.km),
    placa: i.placaFormatado || '',
    valorFipe: i.valorFipe > 0 ? formatMoney(i.valorFipe) : '',
    valorInicial: fechaAgora ? '' : valor,
    fechaAgora: fechaAgora ? valor : null,
    percAbaixoFipe: i.percAbaixoFipe > 0 ? i.percAbaixoFipe : 0,
    cidade: i.cidade,
    uf: i.uf,
    tempo: relativeTime(i.dataAtivacao),
  };
}

// Card da listagem do lojista (GET /v1/negociacoes), consumido por components/vehicle/VehicleCard.vue.
// Os textos ja vem formatados pela API; o card so os exibe.
export function cardFromListagem(i) {
  const fechaAgora = i.valorArremate > 0;
  return {
    imagemUrl: i.imagemCapaFormatadoUrl,
    leilao: !!i.leilao,
    marca: i.marca,
    modelo: i.modelo,
    anoFabricacao: i.anoFabricacao,
    anoModelo: i.anoModelo,
    combustivel: i.combustivel,
    km: i.kmFormatado,
    placa: i.placaFormatado,
    valorFipe: i.valorFipeFormatado,
    valorInicial: i.valorPretendidoFormatado,
    fechaAgora: fechaAgora ? i.valorArremateFormatado : null,
    cidade: i.cidade,
    uf: i.siglaEstado,
    tempo: i.relativeTime,
  };
}
